module.exports = __webpack_public_path__ + "static/media/icon_return.c0abf735.svg";